








































































































import {Component, Prop} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Form, { Send } from '@/components/form-base';
import { DialogForm, FormOverlay } from '@/components/bwaff';

import FlowNavigation from './views/flow-navigation.vue';
import FlowSettings from './views/flow-settings.vue';
import PathSettings from './views/path-settings.vue';
import RuleSettings from './views/rule-settings.vue';
import ErrorAggregator from '@/components/errors/error-aggregator.vue';
import CreateCampaignDialogCountryMixin from '@/views/reports/mixins/flow/create-campaign-dialog-country-mixin';

import FlowAPI from '@/services/rest/bemob/flow';
import TagApi from '@/services/rest/bemob/tag';
import formMock from './config/form-mock';
import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'
import reportUtils from '@/views/reports/report-utils';
import { ErrorParseMethodEnum } from '@/services/models/Enums';
import TagsAPI from '@/services/rest/bemob/tag';
import ReportMixin from '@/views/reports/mixins/report-mixin';
import ApiServices from '@/services';
import _ from 'lodash';
import BasicHelperMixin from '@/components/helpers/basic-helper-mixin';
import OffersLandingsSelectOptionsMixin from '@/views/reports/mixins/flow/offers-landings-select-options-mixin';
import DomainsApi from '@/services/rest/bemob/domains';
import LandingApi from '@/services/rest/bemob/landing';
import OfferApi from '@/services/rest/bemob/offer';

  const md5 = require('md5');

  @Component({
  components: {
    FormOverlay,
    DialogForm,
    FlowNavigation,
    FlowSettings,
    PathSettings,
    RuleSettings,
    ErrorAggregator,
    HeaderButtons
  }
})
export default class DialogFlow extends mixins<Form,OffersLandingsSelectOptionsMixin,BasicHelperMixin, CreateCampaignDialogCountryMixin, ReportMixin>(Form,OffersLandingsSelectOptionsMixin,BasicHelperMixin, CreateCampaignDialogCountryMixin, ReportMixin) {
  @Prop({ default: {} })
  data: any;

  flowApi: FlowAPI = new FlowAPI();
  tagApi: TagApi = new TagApi();
  domainsApi: DomainsApi = new DomainsApi();
  landingApi: LandingApi = new LandingApi();
  offerApi: OfferApi = new OfferApi();
  state: any = {};
  show: boolean = false;
  loading: boolean = false;
  isLoadingDictionary: boolean = false;
  view: string = 'settings';
  active_path: any = [];
  active_rule: any = [];
  rule_placeholder: string = '';
  form: any = this.defaultForm();
  active_path_errors: any = {};
  active_rule_errors: any = {};
  form_errors: any = this.defaultFormErrors;
  reportUtils = reportUtils(this);
  offerOptions: Offer[] = []
  landingOptions: Landing[] = []
  
  errorsRaw: any[] = null;
  //errors: any[] = [];
  errorMessage: string = '';
  errorsControlActive: boolean = false;
  edit: boolean = false;
  flow_id: string = '';

  get isActionsDisabled() {
    return !!(this.edit && this.aclReadOnly({
      workspaceId: this.form.workspaceId,
      id: this.flow_id
    }));
  }

  get itemActions() {
    return {
      cancel: {
        key: 'cancel',
        title: this.t('Cancel'),
        click: () => this.checkClose()
      },
      save: {
        key: 'save',
        title: this.t('Save'),
        disabled: this.isActionsDisabled,
        click: () => this.submit()
      }
    }
  }

  defaultForm() {
    return {
      ...formMock()
    };
  }

  handleChangeRule(rule: any) {
    this.active_rule = rule;
  }

  oldHash: string = '';
  getCurrentHash() {
    return md5(JSON.stringify(this.form));
  }

  get header() {
    return this.t('Create Flow');
  }

  get countryName() {
    return this.getCountryName(this.form.countryId);
  }

  get ruleIndex() {
    return this.form.rules.indexOf(this.active_rule);
  }

  get pathIndex() {
    return this.active_rule 
      ? this.active_rule.paths.indexOf(this.active_path)
      : -1;
  }

  get errors() {
    return this.errorsRaw 
      ? this.translateErrors(this.errorsRaw, this.errorMessage) 
      : [];
  }

  onSaveDictionary(isLoading) {
    this.isLoadingDictionary = isLoading
  } 

  onBusFlowDeleteOffer(ruleIndex: number, pathIndex: number, offerIndex: number) {
    if(this.errorsRaw) {
      const flowNavigation = this.$refs.flowNavigation as FlowNavigation;

      let errors = flowNavigation.processOfferError(ruleIndex, pathIndex, offerIndex);
      this.errorsRaw = flowNavigation.fixOfferErrorIndexes(ruleIndex, pathIndex, offerIndex, errors);
    } 
  }

  onBusFlowDeleteLanding(ruleIndex: number, pathIndex: number, landingIndex: number) {
    if(this.errorsRaw) {
      const flowNavigation = this.$refs.flowNavigation as FlowNavigation;

      let errors = flowNavigation.processLandingError(ruleIndex, pathIndex, landingIndex);
      this.errorsRaw = flowNavigation.fixLandingErrorIndexes(ruleIndex, pathIndex, landingIndex, errors);
    } 
  }

  focusDialog() {
    this.$nextTick(() => {
      const rootDialog = this.$refs.rootDialog as DialogForm;
      rootDialog.focus();
    });
  }

  get allWorkspaceIds() {
    return [...new Set([this.form.workspaceId,...this.$store.getters.allPublicWorkspacesIds])]
  }

  async load() {
    this.form = {
      ...this.defaultForm(),
      workspaceId:this.defaultWorkspace.id,
      ...(this.data.form || {})
    };
  }

  async mounted() {
    this.$on('error', (e: any, payload: any) => {
      this.$store.commit('loading', false);

      this.errorMessage = e.data.message;
      this.errorsRaw = this.parseErrors(e.data.errors, ErrorParseMethodEnum.numerate);
      this.errorsControlActive = true;
    });

    this.bus.on('flow-delete-offer', this.onBusFlowDeleteOffer);
    this.bus.on('flow-delete-landing', this.onBusFlowDeleteLanding);
    this.bus.on('loading-add-dictionary', this.onSaveDictionary);

    this.$store.commit('loading', true);

    this.view = 'settings';
    this.form = this.defaultForm();

    if(!this.$store.state.cache.redirectDomains.isUploaded){
      await this.domainsApi.redirectDomainsPopulateStoreCache()
    }
    
    if(!this.$store.state.cache.landings.isUploaded){
      await this.landingApi.populateStoreCache()
    }

    if(!this.$store.state.cache.offers.isUploaded){
      await this.offerApi.populateStoreCache()
    }

    if(!this.$store.state.cache.tags.flows.isUploaded){
      await this.tagApi.populateStoreCache({type:'flows'})
    }

    await this.load()
      .then(() => {
        this.$helpers.afterBrowserRedraw(() => {
          const flowNavigation = this.$refs.flowNavigation as FlowNavigation;
          flowNavigation.openNavigation();
          flowNavigation.selectFlowSettings();
        })

        this.show = true;
      })
      .finally(() => {
        this.$store.commit('loading', false);
        this.oldHash = this.getCurrentHash();
      });
    this.setLandingOptions()
    this.setOfferOptions()
  }

  checkClose() {
    if (this.oldHash !== this.getCurrentHash() && !this.isActionsDisabled) {
      this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: { onConfirm: () => this.close() }})
    } else {
      this.close();
    }
  }

  close() {
    this.bus.off('flow-delete-offer', this.onBusFlowDeleteOffer);
    this.bus.off('flow-delete-landing', this.onBusFlowDeleteLanding);
    this.bus.off('loading-add-dictionary', this.onSaveDictionary);
    
    this.$emit('close');
  }

  updated(){
    this.$emit('refresh');
  }

  addPath(rule: any, cb: Function) {
    rule.paths.push({
      name: `Path ${rule.paths.length + 1}`,
      landings: [],
      offers: [],
      status: 'active',
      weight: 100,
      directLinking: false
    });
    cb(rule.paths[rule.paths.length - 1], rule);
  }

  deletePath(rule: any, path: any) {
    const flowNavigation = this.$refs.flowNavigation as FlowNavigation;

    const pathIndex = rule.paths.indexOf(path);
    const ruleIndex = this.form.rules.indexOf(rule);

    if(this.errorsRaw) {
      let errors = flowNavigation.processPathError(ruleIndex, pathIndex);
      this.errorsRaw = flowNavigation.fixPathErrorIndexes(ruleIndex, pathIndex, errors);
    }

    rule.paths.splice(pathIndex, 1);

    if (rule.paths.length) {
      flowNavigation.setPath(
        rule.paths[pathIndex] || rule.paths[rule.paths.length - 1],
        rule
      );
      // this.calcPercent(rule.paths)
      this.$emit('refresh');
    }
    else {
      flowNavigation.setRule(rule);
    }
  }

  duplicatePath(rule: any, path: any) {
    const pathIndex = rule.paths.indexOf(path) + 1;
    const newPath = {
      ..._.cloneDeep(path),
      name: path.name + ' ' + this.t('Duplicate'),
    };

    rule.paths.splice(pathIndex, 0, newPath);

    const flowNavigation = this.$refs.flowNavigation as FlowNavigation;
    flowNavigation.setPath(rule.paths[pathIndex], rule);
  }

  addRule() {
    this.form.rules.push({
      name: '',
      default: false,
      conditions: {},
      status: 'active',
      paths: [],
      active: true,
      logicalRelation: 'and'
    });

    let rule = this.form.rules[this.form.rules.length - 1];

    this.$nextTick(()=>{
      this.addPath(rule, () => {
        (this.$refs as any).flowNavigation.setRule(rule);
      });
    })
  }

  duplicateRule(rule: any) {
    const ruleIndex = this.form.rules.indexOf(rule) + 1;
    const newRule = {
      ..._.cloneDeep(rule),
      name: `${rule.name} ${this.t('Duplicate')}`,
    };

    this.form.rules.splice(ruleIndex, 0, newRule);

    const flowNavigation = this.$refs.flowNavigation as FlowNavigation;
    flowNavigation.setRule(newRule);
  }

  deleteRule(rule: any) {
    const flowNavigation = this.$refs.flowNavigation as FlowNavigation;

    const ruleIndex = this.form.rules.indexOf(rule);

    if(this.errorsRaw) {
      const errors = flowNavigation.processRuleError(ruleIndex);
      this.errorsRaw = flowNavigation.fixRuleErrorIndexes(ruleIndex, errors);
    }

    this.form.rules.splice(ruleIndex, 1);

    flowNavigation.setRule(this.form.rules[ruleIndex] || this.form.rules[this.form.rules.length - 1]);
  }

  get self() {
    return this;
  }

  processForm(form){
    const preparedForm = {...form}
    preparedForm.tags=preparedForm?.tags?.map((item)=>item?.id ? item.name : item);
    return preparedForm;
  }

  onSubmit() {
    return this.flowApi.postCreate(this.processForm(this.form))
      .then((res: any) => {
        this.flow_id = res.data.payload.id;
        this.trackAnalytics('flow_create')
        this.data?.onConfirm?.(res.data.payload)
        return Promise.resolve(res);
      });
  }

  get defaultFormErrors() {
    return {
      name: false,
      rules: [] as any[]
    };
  }

  get successText() {
    return this.edit ? this.t('Flow has been changed') : this.t('Flow has been saved')
  }

  @Send()
  submit() {
    if (this.isLoadingDictionary) return

    this.loading = true;

    return this.onSubmit()
      .then(() => {
        this.$nextTick(async() => {
          await ApiServices.getUserProfile();
          this.bus.emit('toast-success', this.successText);
          this.bus.emit('refresh-report');

          this.close();
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }

  onChangeWorkspace(value: any) {
    const {name, tags, countryId} = this.form;
    this.form = {
      ...this.defaultForm(),
      workspaceId:value,
      name,
      tags,
      countryId
    };
    this.setLandingOptions()
    this.setOfferOptions()
  }

  onChangeCountry(value: any) {
    this.setLandingOptions()
    this.setOfferOptions()
  }
  
  trackAnalytics(event){
    const { name} = this.form;

    const rules= this.form.rules.reduce((acc,rule)=>{
      Object.keys(rule.conditions).forEach((condition)=>acc.push(condition))
      return acc;
    },[]) || []
    
    this.$mixpanel?.track(event, {
      name,
      rules
    })
  }
}
